import { render, staticRenderFns } from "./Base64File.vue?vue&type=template&id=11fca4cd&scoped=true"
import script from "./Base64File.vue?vue&type=script&lang=js"
export * from "./Base64File.vue?vue&type=script&lang=js"
import style0 from "./Base64File.vue?vue&type=style&index=0&id=11fca4cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fca4cd",
  null
  
)

export default component.exports